import { Card, CardContent, Typography } from '@mui/material';

export const MiniCardGrafico = ({ title, subtitle, total, children }) => {
  return (
    <Card sx={{ m: 0, p: 0, height: '150px' }}>
      <CardContent sx={{ pt: 1, pb: 0, px: 2, height: '90px' }}>
        <Typography variant='subtitle2' color='text.secondary' fontSize={11}>
          {title}
        </Typography>
        <Typography variant='caption' color='text.secondary'>
          {subtitle}
        </Typography>
        <Typography variant='h5' fontWeight='bold'>
          {total.toLocaleString()}
        </Typography>
      </CardContent>
      <CardContent sx={{ m: 0, p: 0, paddingBottom: '0 !important', height: '60px' }}>
        {children}
      </CardContent>
    </Card>
  );
};
